import { computed, ref, reactive, nextTick, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3edf098"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "device-id-input-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "rgba(0, 0, 0, 0.45)",
    "font-size": "12px",
    "margin-top": "2px"
  }
}, "批量赠送时一行一个", -1));
const _hoisted_3 = {
  class: "content-toolbar"
};
const _hoisted_4 = {
  class: "toolbar-left"
};
const _hoisted_5 = {
  key: 0,
  class: "toolbar-right"
};
const _hoisted_6 = {
  class: "text-link"
};
const _hoisted_7 = {
  class: "content-footer"
};
const _hoisted_8 = {
  key: 1,
  class: "json-tip"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "split"
}, null, -1));
const _hoisted_10 = {
  key: 0,
  class: "json-tip info"
};
import { DownOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
import { addGivenGift, retryGivenGift } from '@/api/givenGift';
import { awaitWrap, filterOption, OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import { GIFT_TEMPLATES } from '../constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'PropsAddModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    editItem: null
  },
  emits: ['update:modalVisible', 'submitGiven', 'updateList', 'resetEdit'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const rules = computed(() => ({
      deviceId: [{
        required: true,
        message: '请输入用户设备ID',
        trigger: 'blur'
      }],
      // 分区模式的必填与格式提示统一显示在操作行左侧，不走 antd 的 explain
      prodId: isZoneMode.value ? [] : [{
        required: true,
        message: '请输入赠送内容',
        trigger: 'blur'
      }],
      price: [{
        required: true,
        message: '请输入商品价格',
        trigger: 'blur'
      }],
      prodNum: [{
        required: true,
        message: '请输入商品数量',
        trigger: 'blur'
      }],
      reason: [{
        required: true,
        message: '请输入赠送理由',
        trigger: 'blur'
      }]
    }));
    const givenForm = ref({
      deviceId: '',
      prodId: '',
      price: null,
      reason: '',
      prodNum: 1
    });
    const givenRef = ref(null);
    const productList = ref([]);
    const loading = ref(false); // loading状态
    const isExpanded = ref(false); // 控制设备ID输入框是否展开
    const contentWrapRef = ref(null);
    const contentMode = ref('normal'); // 赠送内容录入模式：分区 / 非分区
    const isZoneMode = computed(() => contentMode.value === 'zone');
    const jsonTip = ref(null); // 赠送内容 JSON 校验提示
    // 内容以 [ 或 { 开头则形似 JSON，仅用于非分区模式下的软提示，不参与拦截
    const isJsonLike = value => /^[[{]/.test((value || '').trim());
    const showZoneHint = computed(() => !isZoneMode.value && isJsonLike(givenForm.value.prodId));
    // 两种模式各自缓存已输入内容，互不覆盖
    const contentCache = reactive({
      zone: '',
      normal: ''
    });
    const prevMode = ref('normal');
    // 切换录入模式：暂存当前内容、回填目标模式内容，并清掉校验态（不触发表单校验）
    const changeContentMode = () => {
      contentCache[prevMode.value] = givenForm.value.prodId;
      givenForm.value.prodId = contentCache[contentMode.value];
      prevMode.value = contentMode.value;
      jsonTip.value = null;
      nextTick(() => {
        var _givenRef$value;
        return (_givenRef$value = givenRef.value) === null || _givenRef$value === void 0 ? void 0 : _givenRef$value.clearValidate('prodId');
      });
    };
    // 套用模板
    const applyTemplate = ({
      key
    }) => {
      const template = GIFT_TEMPLATES.find(item => item.label === key);
      if (!template) return;
      givenForm.value.prodId = template.value;
      jsonTip.value = null;
      nextTick(() => {
        var _givenRef$value2;
        return (_givenRef$value2 = givenRef.value) === null || _givenRef$value2 === void 0 ? void 0 : _givenRef$value2.clearValidate('prodId');
      });
    };
    // JSON 原生报错的中文说明。第三项为 true 时，错误实际出在上一处内容的末尾
    // （解析器是在遇到意外 token 的位置报错，但缺的逗号在前一行行尾）
    const JSON_ERROR_DICT = [[/Unexpected end of JSON input/i, '内容不完整，缺少结尾的 } 或 ]'], [/Expected ',' or '}' after property value/i, '缺少逗号 , 或右花括号 }', true], [/Expected ',' or ']' after array element/i, '缺少逗号 , 或右方括号 ]', true], [/Expected double-quoted property name/i, '属性名需用英文双引号包裹（也可能是多了一个逗号）'], [/Expected property name or '}'/i, '属性名需用英文双引号包裹'], [/Expected ':' after property name/i, '属性名后缺少冒号'], [/Unexpected non-whitespace character after JSON/i, 'JSON 结束后还有多余内容'], [/Unexpected token '(.+?)'/i, "存在非法字符 '$1'"]];
    // 解析 JSON.parse 的报错：定位字符偏移、换算行号、给出中文原因
    const describeJsonError = (rawMessage, content) => {
      let index = -1;
      const lineColumn = rawMessage.match(/line (\d+) column (\d+)/i);
      const position = rawMessage.match(/position (\d+)/i);
      if (position) {
        index = Number(position[1]);
      } else if (lineColumn) {
        const lines = content.split('\n');
        const before = lines.slice(0, Number(lineColumn[1]) - 1).join('\n');
        index = (before ? before.length + 1 : 0) + Number(lineColumn[2]) - 1;
      }
      let reason = '';
      let blamePrevious = false;
      for (const [pattern, text, blamePrev] of JSON_ERROR_DICT) {
        const matched = rawMessage.match(pattern);
        if (matched) {
          var _matched$;
          reason = text.replace('$1', (_matched$ = matched[1]) !== null && _matched$ !== void 0 ? _matched$ : '');
          blamePrevious = !!blamePrev;
          break;
        }
      }
      if (!reason) reason = '格式不合法';
      // 缺逗号类错误：解析器报的是下一行开头，回退到上一处非空白字符（真正该补的位置）
      if (blamePrevious && index > 0) {
        let cursor = index - 1;
        while (cursor >= 0 && /\s/.test(content[cursor])) cursor -= 1;
        if (cursor >= 0) index = cursor + 1;
      }
      const line = index >= 0 ? content.slice(0, index).split('\n').length : 0;
      return {
        index,
        message: line ? `第 ${line} 行${blamePrevious ? '末尾' : ''}：${reason}` : reason
      };
    };
    // 校验 JSON 语法，并要求顶层是对象或数组（JSON 标准允许 333、true 这类标量，业务上不合法）
    const parseContent = () => {
      const content = givenForm.value.prodId;
      try {
        const parsed = JSON.parse(content);
        if (typeof parsed !== 'object' || parsed === null) {
          return {
            ok: false,
            message: '内容需为 JSON 对象或数组',
            index: -1
          };
        }
        return {
          ok: true,
          message: '',
          index: -1
        };
      } catch (e) {
        const detail = describeJsonError((e === null || e === void 0 ? void 0 : e.message) || '', content);
        return {
          ok: false,
          message: detail.message,
          index: detail.index
        };
      }
    };
    // 校验失败时把出错那一行整行选中并滚到可见位置，省得用户自己数行
    const highlightErrorLine = () => {
      var _contentWrapRef$value;
      const {
        ok,
        index
      } = parseContent();
      if (ok || index < 0) return;
      const textarea = (_contentWrapRef$value = contentWrapRef.value) === null || _contentWrapRef$value === void 0 ? void 0 : _contentWrapRef$value.querySelector('textarea');
      if (!textarea) return;
      const content = givenForm.value.prodId;
      const lineStart = content.lastIndexOf('\n', Math.max(index - 1, 0)) + 1;
      const lineEnd = content.indexOf('\n', index) === -1 ? content.length : content.indexOf('\n', index);
      textarea.focus();
      textarea.setSelectionRange(lineStart, lineEnd);
      // 让出错行尽量落在可视区域中部
      const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight) || 22;
      const lineNo = content.slice(0, index).split('\n').length;
      textarea.scrollTop = Math.max((lineNo - 3) * lineHeight, 0);
    };
    const formatJson = () => {
      if (!isJsonLike(givenForm.value.prodId)) {
        jsonTip.value = {
          type: 'info',
          text: '当前内容不是 JSON，无需格式化'
        };
        return;
      }
      const result = parseContent();
      if (!result.ok) {
        jsonTip.value = {
          type: 'error',
          text: result.message
        };
        nextTick(highlightErrorLine);
        return;
      }
      givenForm.value.prodId = JSON.stringify(JSON.parse(givenForm.value.prodId), null, 2);
      jsonTip.value = {
        type: 'success',
        text: '已格式化并校验通过'
      };
    };
    // 分区模式下赠送内容的校验：内容形似 JSON（以 [ 或 { 开头）才走 JSON 那一套，
    // 普通文本按自定义内容处理，不校验、不拦截
    const validateJson = () => {
      var _givenForm$value$prod;
      if (!((_givenForm$value$prod = givenForm.value.prodId) !== null && _givenForm$value$prod !== void 0 && _givenForm$value$prod.trim())) {
        jsonTip.value = {
          type: 'error',
          text: '请输入赠送内容'
        };
        return false;
      }
      if (!isJsonLike(givenForm.value.prodId)) {
        jsonTip.value = {
          type: 'info',
          text: '当前内容不是 JSON，无需校验'
        };
        return true;
      }
      const result = parseContent();
      if (!result.ok) {
        jsonTip.value = {
          type: 'error',
          text: result.message
        };
        nextTick(highlightErrorLine);
        return false;
      }
      jsonTip.value = {
        type: 'success',
        text: '校验通过'
      };
      return true;
    };
    // 切换展开/收起状态
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value;
    };
    const closeModal = () => {
      var _givenRef$value3;
      givenForm.value = {
        deviceId: '',
        prodId: '',
        price: null,
        prodNum: 1,
        reason: ''
      };
      (_givenRef$value3 = givenRef.value) === null || _givenRef$value3 === void 0 || _givenRef$value3.resetFields();
      isExpanded.value = false;
      jsonTip.value = null;
      contentMode.value = 'normal';
      prevMode.value = 'normal';
      contentCache.zone = '';
      contentCache.normal = '';
      emit('update:modalVisible', false);
      emit('resetEdit');
    };
    const submitGiven = () => {
      // 先同步标出赠送内容的问题，保证与其它字段的错误提示同时出现
      const contentOk = productList.value.length || !isZoneMode.value || validateJson();
      givenRef.value.validate().then(async () => {
        if (!contentOk) return;
        const deviceIds = givenForm.value.deviceId.split(/\r?\n/).filter(id => id.trim());
        // 如果没有设备ID，就不提交
        if (!deviceIds.length) {
          message.error('请输入至少一个设备ID');
          return;
        }
        loading.value = true;
        // 使用批量接口处理所有情况
        const params = {
          prodId: givenForm.value.prodId,
          deviceIdList: deviceIds.map(id => id.trim()),
          prodNum: givenForm.value.prodNum || 1,
          giftReason: String(givenForm.value.reason),
          dbtId: props.dbtId
        };
        // 如果是重试场景，添加id参数
        if (givenForm.value.id) {
          params.id = givenForm.value.id;
        }
        const [err, data] = await awaitWrap(givenForm.value.id ? retryGivenGift(params) : addGivenGift(params));
        if (data && data.code === OK) {
          const {
            successCount = 0,
            failCount = 0
          } = data.data || {};
          if (successCount > 0 || !data.data) {
            // 兼容没有返回data.data的情况
            let successMessage = '操作成功';
            if (data.data) {
              successMessage = `成功赠送 ${successCount} 条记录${failCount > 0 ? `，失败 ${failCount} 条` : ''}`;
            }
            message.success(successMessage);
            emit('updateList');
            closeModal();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '道具赠送',
                element_name: '赠送道具'
              }
            });
          } else if (failCount > 0) {
            message.error(`赠送失败，请稍后重试`);
          }
        } else {}
        loading.value = false;
      });
    };
    const changeProd = () => {
      const item = productList.value.find(item => item.value === givenForm.value.prodId) || {
        prodPrice: 0
      };
      if (item) {
        givenForm.value.price = item.prodPrice;
      }
    };
    /*watch(
        () => props.modalVisible,
        (val) => {
          if (val) {
            getProductList()
          }
        },
        {
          immediate: true,
        },
      )*/
    watch(() => props.editItem, n => {
      var _Object$keys;
      if (n && (_Object$keys = Object.keys(n)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        givenForm.value = {
          ...n
        };
        // 重试回显：内容形似 JSON 时按分区模式展示，避免长 JSON 挤在单行输入框里
        contentMode.value = isJsonLike(n.prodId) ? 'zone' : 'normal';
        prevMode.value = contentMode.value;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_radio_button = _resolveComponent("a-radio-button");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        class: "given-modal",
        title: "赠送道具",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: submitGiven,
        "confirm-loading": loading.value,
        "ok-text": "赠送",
        width: "540px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "propsForm",
          model: givenForm.value,
          ref_key: "givenRef",
          ref: givenRef,
          rules: _unref(rules)
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "设备ID",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "deviceId",
            required: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_textarea, {
              value: givenForm.value.deviceId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => givenForm.value.deviceId = $event),
              placeholder: "请输入用户设备ID",
              disabled: !!givenForm.value.id,
              "auto-size": {
                minRows: isExpanded.value ? 5 : 1,
                maxRows: isExpanded.value ? 10 : 1
              }
            }, null, 8, ["value", "disabled", "auto-size"]), _createVNode(_component_a_button, {
              type: "link",
              onClick: toggleExpand,
              class: "expand-button"
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                "icon-class": isExpanded.value ? 'close_arrow' : 'open'
              }, null, 8, ["icon-class"])]),
              _: 1
            }), _hoisted_2])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "赠送内容",
            class: _normalizeClass(["content-item", {
              'zone-mode': _unref(isZoneMode)
            }]),
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "prodId",
            required: !_unref(isZoneMode)
          }, {
            default: _withCtx(() => {
              var _jsonTip$value;
              return [!productList.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_radio_group, {
                value: contentMode.value,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => contentMode.value = $event),
                "button-style": "solid",
                size: "small",
                onChange: changeContentMode
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_button, {
                  value: "normal"
                }, {
                  default: _withCtx(() => [_createTextVNode("非分区")]),
                  _: 1
                }), _createVNode(_component_a_radio_button, {
                  value: "zone"
                }, {
                  default: _withCtx(() => [_createTextVNode("分区")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["value"]), _createVNode(_component_a_tooltip, {
                title: "带分区产品可以使用分区模板，非分区产品可以自定义"
              }, {
                default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
                  class: "tip-icon"
                })]),
                _: 1
              })]), _unref(isZoneMode) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_a_dropdown, {
                trigger: ['hover'],
                placement: "bottomRight"
              }, {
                overlay: _withCtx(() => [_createVNode(_component_a_menu, {
                  onClick: applyTemplate
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GIFT_TEMPLATES), item => {
                    return _openBlock(), _createBlock(_component_a_menu_item, {
                      key: item.label
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1024);
                  }), 128))]),
                  _: 1
                })]),
                default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createTextVNode(" 使用模板 "), _createVNode(_unref(DownOutlined), {
                  class: "link-arrow"
                })])]),
                _: 1
              })])) : _createCommentVNode("", true)]), _unref(isZoneMode) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", {
                ref_key: "contentWrapRef",
                ref: contentWrapRef
              }, [_createVNode(_component_a_textarea, {
                value: givenForm.value.prodId,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => givenForm.value.prodId = $event),
                placeholder: "请输入赠送内容",
                "auto-size": {
                  minRows: 8,
                  maxRows: 8
                },
                style: _normalizeStyle(((_jsonTip$value = jsonTip.value) === null || _jsonTip$value === void 0 ? void 0 : _jsonTip$value.type) === 'success' ? {
                  borderColor: '#52c41a'
                } : {}),
                onChange: _cache[3] || (_cache[3] = $event => jsonTip.value = null)
              }, null, 8, ["value", "style"])], 512), _createElementVNode("div", _hoisted_7, [jsonTip.value ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: jsonTip.value.text
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: _normalizeClass(["json-tip", jsonTip.value.type])
                }, _toDisplayString(jsonTip.value.text), 3)]),
                _: 1
              }, 8, ["title"])) : (_openBlock(), _createElementBlock("span", _hoisted_8)), _createElementVNode("div", {
                class: "json-actions"
              }, [_createElementVNode("span", {
                class: "text-link",
                onClick: formatJson
              }, "格式化"), _hoisted_9, _createElementVNode("span", {
                class: "text-link",
                onClick: validateJson
              }, "格式校验")])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createVNode(_component_a_input, {
                value: givenForm.value.prodId,
                "onUpdate:value": _cache[4] || (_cache[4] = $event => givenForm.value.prodId = $event),
                valueModifiers: {
                  trim: true
                },
                placeholder: "请输入赠送内容"
              }, null, 8, ["value"]), _unref(showZoneHint) ? (_openBlock(), _createElementBlock("div", _hoisted_10, "内容看起来是 JSON，如为分区产品请切换到「分区」")) : _createCommentVNode("", true)], 64))], 64)) : (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                "show-search": "",
                value: givenForm.value.prodId,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => givenForm.value.prodId = $event),
                placeholder: "请选择内购ID",
                options: productList.value,
                onChange: changeProd,
                "filter-option": _unref(filterOption)
              }, null, 8, ["value", "options", "filter-option"]))];
            }),
            _: 1
          }, 8, ["class", "required"]), _createVNode(_component_a_form_item, {
            label: "赠送数量",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "prodNum",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              precision: 0,
              value: givenForm.value.prodNum,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => givenForm.value.prodNum = $event),
              placeholder: "请输入赠送数量",
              min: 1
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "赠送理由",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "reason",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: givenForm.value.reason,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => givenForm.value.reason = $event),
              placeholder: "请输入赠送理由",
              maxlength: 50
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});